<template>
  <div>
    <!-- 添加配置文件 -->
    <el-button
      type="primary"
      size="mini"
      class="elinput"
      @click="centerDialogVisible=true"
      v-if="Permission.indexOf(118)!=-1"
    >{{$t('lang.configuration.Add')}}</el-button>
    <!--xlsx表格导出-->
    <xlsx style="margin-bottom: 0.2rem;margin-top: 0.2rem" v-if="Permission.indexOf(110)!=-1"></xlsx>
<!--    表格组件-->
    <TableComponent
      :Columns="Columns"
      :ColuumnsButton="ColuumnsButton"
      :data="data"
      :seek="seek"
      :RowKey="'cfId'"
      :ColuumnsButtonWidth="220"
      :DeleteTitle="$t('lang.configuration.t_config_file')"
      @GetUsername="GetUsername"
      @DownloadFile="DownloadFile"
      @showcenterDialogVisibles="showcenterDialogVisibles"
      @delConfigurationFile="delConfigurationFile"
      @sortChange="sortChange"
    />
    <!--分页组件-->
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
      :show-file-list="false"
    ></pagination>
    <!-- 添加弹出框 -->
    <el-dialog :title="$t('lang.configuration.Configuration')" :visible.sync="centerDialogVisible" width="30%" center>
      <div style="text-align:center;">
        <el-upload
          ref="upload"
          class="upload-demo"
          action="/api/configurationFileManager/addConfigurationFile"
          :headers="Headers"
          multiple
          drag
          :auto-upload="false"
          :limit="1"
          accept=".tar.gz"
          :data="uploadpack"
          :on-success="uploadsuccess">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            <em>{{$t('lang.configuration.add_action')}}</em>
          </div>
          <div class="el-upload__tip" slot="tip" style="text-align:center">{{$t('lang.configuration.file_name')}}</div>
        </el-upload>
        <br>
        <p>
          <span class="tetxp">{{$t('lang.configuration.noteId')}}</span>
          <el-input size="mini" v-model="uploadpack.remark" :placeholder="$t('lang.configuration.Optional')" class="adduserinput"></el-input>
        </p>
        <el-button type="primary" size="mini" @click="submitUpload">{{$t('lang.configuration.uploaders')}}</el-button>
      </div>
    </el-dialog>
    <!-- 修改弹出框 -->
    <el-dialog :title="$t('lang.configuration.modifycollection')" :visible.sync="centerDialogVisibles" width="30%" center>
      <div style="text-align:center;">
        <el-upload
          ref="setupload"
          class="upload-demo"
          action="/api/configurationFileManager/updateConfigurationFile"
          multiple
          drag
          accept=".tar.gz"
          :headers="Headers"
          :auto-upload="false"
          :limit="1"
          :data="setuploadpack"
          :on-success="setuploadsuccess">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            <em>{{$t('lang.configuration.add_action')}}</em>
          </div>
          <div class="el-upload__tip" slot="tip" style="text-align:center">{{$t('lang.configuration.file_name')}}</div>
        </el-upload>
        <br>
        <p>
          <span class="tetxp">{{$t('lang.configuration.noteId')}}</span>
          <el-input
            size="mini"
            v-model="setuploadpack.remark"
            :placeholder="$t('lang.configuration.Optional')"
            class="adduserinput">
          </el-input>
        </p>
        <el-button type="primary" size="mini" @click="setsubmitUpload">{{$t('lang.configuration.uploaders')}}</el-button>
      </div>
    </el-dialog>
    <!-- <Dialog :Show="DialogShow" @DialogResponse="DialogResponse" :title="'配置权限'"></Dialog> -->
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import xlsx from "@/components/xlsx";
import {
  listConfigurationFile,
  delConfigurationFile,
  queryKeyword
} from "@/api/configuration"
import { getPermission,getToken } from "../../../cookie/cookie"
import { PublicComponent } from "../../../mixins/common"
import Dialog from '@/components/Dialog'
import TableComponent from '@/components/TableComponent/index'
import { Columns,ColuumnsButton } from "./TableConfig";

export default {
  mixins: [PublicComponent],
  data() {
    return {
      Columns:Columns,
      ColuumnsButton:ColuumnsButton,
      //用户权限
      Permission: [],
      data: [],
      //上传文件弹出
      centerDialogVisible: false,
      //修改文件弹出
      centerDialogVisibles: false,
      value: "",
      input: "",
      currentPage4: 1,
      //搜索框
      seek: {
        cfName: "",
        cfSize: "",
        username: "",
        cfCreate: "",
        cfRemarks: ""
      },
      //排序按钮
      sort: {
        cfName: null,
        cfSize: null,
        username: null,
        cfCreate: null,
        cfRemarks: null
      },
      //上传额外参数
      uploadpack: {
        cfId: 0,
        remark: ""
      },
      //修改额外参数
      setuploadpack: {
        cfId: 0,
        remark: ""
      },
      //下载路径
      url: window.location.port==''?'http://'+document.domain:
      'http://'+document.domain+':'+window.location.port,
      //权限弹出框
      DialogShow:false,
      //上传添加token
      Headers:{
        token:getToken()
      }
    };
  },
  components: {
    pagination,
    xlsx,
    Dialog,
    TableComponent
  },
  methods: {
    //上传返回提示
    uploadsuccess(response, file, fileList) {
      if (response.code == 0) {
        this.$message({
          showClose: true,
          message: this.$t('lang.configuration.justUploaded'),
          type: "success"
        });
        //上传完成刷新列表
        this.queryKeyword();
        this.centerDialogVisible = !this.centerDialogVisible;
        this.$refs.upload.clearFiles();
        this.uploadpack = {
          cfId: 0,
          remark: null
        };
      } else {
        this.$message({
          showClose: true,
          message: this.$t('lang.configuration.successfully'),
          type: "warning"
        });
      }
    },
    //下载文件
    DownloadFile(row){
      console.log('downloadFile');
      console.log(this.url);
      
      window.open(this.url+'/api/configurationFileManager/download?downloadUrl='+row.cfPath+'&realFileName='+row.cfName)
    },
    //上传文件
    submitUpload() {
      this.$refs.upload.submit();
    },
    //删除文件
    delConfigurationFile(row) {
      delConfigurationFile(row.cfId).then(res => {
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            message: this.$t('lang.configuration.TestDelete'),
            type: "success"
          });
          this.queryKeyword();
          this.uploadpack = {
            cfId: 0,
            remark: null
          };
        } else {
          this.$message({
            showClose: true,
            message: this.$t('lang.configuration.bdb_delete'),
            type: "warning"
          });
        }
      });
    },
    //表格排序
    sortChange(column) {
      //每次点击清空一次排序的赋值
      this.sort = {
        cfName: null,
        cfSize: null,
        username: null,
        cfCreate: null,
        cfRemarks: null
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (column != null) {
        label = column.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (column != null) {
        if (column.order == "ascending") {
          sortlist = 0;
        } else if (column.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      if (label == this.$t('lang.configuration.createFile')) {
        this.sort.cfName = sortlist;
      } else if (label == this.$t('lang.configuration.ntfs_file_open')) {
        this.sort.cfSize = sortlist;
      } else if (label == this.$t('lang.configuration.heir_do')) {
        this.sort.username = sortlist;
      } else if (label == this.$t('lang.configuration.Upload')) {
        this.sort.cfCreate = sortlist;
      } else if (label == this.$t('lang.configuration.noteId')) {
        this.sort.cfRemarks = sortlist;
      }
    },
    //查询排序
    queryKeyword() {
      queryKeyword(
        [
          this.seek.cfName,
          this.seek.cfSize,
          this.seek.username,
          this.seek.cfCreate,
          this.seek.cfRemarks
        ],
        this.offset,
        this.limit,
        this.sort
      ).then(res => {
        this.data = res.data.data.list;
        this.total = res.data.data.total;
        this.data.unshift({});
      });
    },
    //修改获取参数
    //弹出修改框并且获取需要修改的软件包id
    showcenterDialogVisibles(row) {
      this.setuploadpack.cfId = row.cfId;
      this.setuploadpack.remark = row.cfRemarks;
      this.centerDialogVisibles = !this.centerDialogVisibles;
    },
    //修改文件
    setsubmitUpload() {
      this.$refs.setupload.submit();
    },
    //修改上传返回提示
    setuploadsuccess(response, file, fileList) {
      if (response.code == 0) {
        this.$message({
          showClose: true,
          message: this.$t('lang.configuration.m_pr_modifyS'),
          type: "success"
        });
        this.queryKeyword();
        this.centerDialogVisibles = !this.centerDialogVisibles;
        this.setuploadpack = {
          cfId: 0,
          remark: null
        };
        this.$refs.setupload.clearFiles()
      } else {
        this.$message({
          showClose: true,
          message: this.$t('lang.configuration.onCallModifying'),
          type: "warning"
        });
      }
    },
    //设置固件权限,弹出固件权限弹出框
    SetFirmwarePermission(index){
      this.DialogShow=true
      console.log(index)
    },
    //接收固件权限弹出框返回值
    DialogResponse(props){
      this.DialogShow=props
    },
    //获取上传人
    GetUsername(row){
      return row.user.username
    }
  },
  mounted() {
    //获取列表数据
    listConfigurationFile(this.offset, this.limit).then(res => {
      this.data = res.data.data.list;
      this.total = res.data.data.total;
      //给第一行添加一条空数据
      this.data.unshift({});
    });
    this.Permission = getPermission();
  }
};
</script>

<style scoped>
.elinput {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}
.spanov {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.25rem;
  height: 41px;
  display: block;
  line-height: 41px;
}
.tetxp {
  display: inline-block;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}
.adduserinput {
  display: inline-block;
  width: 70%;
  margin: 0.2rem;
}
</style>
